<page-title [title]="title"></page-title>
<p>Navegue pelas abas para visualizar os especialistas, clique para ver mais detalhes.</p>
<mat-tab-group *ngIf="isPractitionersLoaded">
  <mat-tab label="Ativos">
    <div class="col-xs-12 col-lg-6" *ngFor="let practitioner of practitionerActive">
      <mat-card (click)="openPractitionerDetailsForm(practitioner)">
        <!-- <div class="col-xs-5 col-md-3">
                  <page-avatar [gender]="practitioner.gender" [avatar]="practitioner.avatar"></page-avatar> 
                </div>-->
        <div class="col-xs-12 col-md-12">
          <div class="content">
            <b> {{ getPrefix(practitioner) }} {{ practitioner.practitioner_name }}</b> <br />
            {{ getSpecialization(practitioner) }} <br />
            <!--  {{ getPrefix(practitioner) }}  {{practitioner.name }} <br> 
                        {{ getSpecialization(practitioner) }}</b> <br>
                        {{ getCity(practitioner) }}-->
          </div>
        </div>
      </mat-card>
    </div>
  </mat-tab>
  <mat-tab label="Inativos">
    <div class="col-xs-12 col-lg-6" *ngFor="let practitioner of practitionerInactive">
      <mat-card (click)="openPractitionerDetailsForm(practitioner)">
        <!-- <div class="col-xs-5 col-md-3">
                    <page-avatar [gender]="practitioner.gender" [avatar]="practitioner.avatar"></page-avatar>
                </div> -->
        <div class="col-xs-12 col-md-12">
          <div class="content">
            <b> {{ getPrefix(practitioner) }} {{ practitioner.practitioner_name }}</b> <br />
            {{ getSpecialization(practitioner) }} <br />
          </div>
        </div>
      </mat-card>
    </div>
  </mat-tab>
  <mat-tab label="Pendente aprovação">
    <ng-template mat-tab-label>
      Pendente aprovação

      <div matBadge="5" class="c-badge"></div>
    </ng-template>

    <div class="col-xs-12 col-lg-6" *ngFor="let practitioner of practitionerPending">
      <mat-card (click)="openPractitionerDetailsForm(practitioner)">
        <div class="col-xs-12 col-md-12">
          <div class="content">
            <b> {{ getPrefix(practitioner) }} {{ practitioner.practitioner_name }}</b> <br />
            {{ getSpecialization(practitioner) }} <br />
          </div>
        </div>
      </mat-card>
    </div>
  </mat-tab>
</mat-tab-group>

<div *ngIf="!isPractitionersLoaded">
  <mat-spinner></mat-spinner>
</div>

<div class="actions">
  <button mat-flat-button color="primary" (click)="openForm()">Vincular novo especialista</button>
</div>
